import { BaseEntity } from '../../models';
import { LinhaProducao } from '../linha-producao';

export class NaturezaVenda implements BaseEntity {
    id: number;
    idEmpresa: number;
    codigo: number;
    nome: string;
    situacao: number;
    idLinhaProducao: number;
    linhaProducao: LinhaProducao;

    // Integração ERP
    codigoIntegracaoErp: string;
    idIntegracaoErp: number;
    integradoErp: boolean;
    integracaoErpSistema: number;
    dataIntegracaoErp: Date;
    dataUltimaIntegracaoErp: Date;
}
